// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctScanSizeDuplicate_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.50072 4.5H5.00036V19.5H7.5L4 24L0.5 19.5H3.00036V4.5H0.500721L4.00072 0L7.50072 4.5Z" class="svg-bg"/>
  <path d="M15.5968 16.0005H9.60881V14.7405L11.7568 12.5685C12.1888 12.1205 12.5368 11.7485 12.8008 11.4525 13.0648 11.1485 13.2568 10.8765 13.3768 10.6365 13.4968 10.3885 13.5568 10.1245 13.5568 9.8445 13.5568 9.5005 13.4608 9.2445 13.2688 9.0765 13.0848 8.9085 12.8328 8.8245 12.5128 8.8245 12.1848 8.8245 11.8648 8.9005 11.5528 9.0525 11.2408 9.2045 10.9128 9.4205 10.5688 9.7005L9.58481 8.5365C9.82481 8.3285 10.0848 8.1325 10.3648 7.9485 10.6448 7.7565 10.9648 7.6045 11.3248 7.4925 11.6928 7.3725 12.1328 7.3125 12.6448 7.3125 13.2048 7.3125 13.6848 7.4165 14.0848 7.6245 14.4928 7.8245 14.8048 8.1005 15.0208 8.4525 15.2448 8.7965 15.3568 9.1885 15.3568 9.6285 15.3568 10.1005 15.2608 10.5325 15.0688 10.9245 14.8848 11.3165 14.6128 11.7045 14.2528 12.0885 13.9008 12.4725 13.4728 12.8965 12.9688 13.3605L11.8648 14.3925V14.4765H15.5968V16.0005ZM24 16.0005H21.924L19.932 12.7605 17.94 16.0005H15.996L18.84 11.5845 16.176 7.4325H18.18L20.028 10.5165 21.84 7.4325H23.796L21.108 11.6805 24 16.0005Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctScanSizeDuplicate is a generated icon component.
 */
let IconMedOctScanSizeDuplicate = IconMedOctScanSizeDuplicate_1 = class IconMedOctScanSizeDuplicate extends IconBaseElement {
    render() {
        return html `${IconMedOctScanSizeDuplicate_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctScanSizeDuplicate.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctScanSizeDuplicate = IconMedOctScanSizeDuplicate_1 = __decorate([
    customElement('zui-icon-med-oct-scan-size-duplicate')
], IconMedOctScanSizeDuplicate);
export { IconMedOctScanSizeDuplicate };
